import SpinnerLoading from './SpinnerLoading';

export default SpinnerLoading;
